import parse from "html-react-parser";
import React, { useContext, useEffect, useRef, useState } from "react";
import { FaWindowClose } from "react-icons/fa";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import img1 from "../../assets/images/screen1.jpg";
import img10 from "../../assets/images/screen10.jpg";
import img11 from "../../assets/images/screen11.jpg";
import img12 from "../../assets/images/screen12.jpg";
import img13 from "../../assets/images/screen13.jpg";
import img14 from "../../assets/images/screen14.jpg";
import img15 from "../../assets/images/screen15.jpg";
import img16 from "../../assets/images/screen16.jpg";
import img17 from "../../assets/images/screen17.jpg";
import img18 from "../../assets/images/screen18.jpg";
import img19 from "../../assets/images/screen19.jpg";
import img2 from "../../assets/images/screen2.jpg";
import img20 from "../../assets/images/screen20.jpg";
import img21 from "../../assets/images/screen21.jpg";
import img3 from "../../assets/images/screen3.jpg";
import img4 from "../../assets/images/screen4.jpg";
import img5 from "../../assets/images/screen5.jpg";
import img6 from "../../assets/images/screen6.jpg";
import img7 from "../../assets/images/screen7.jpg";
import img8 from "../../assets/images/screen8.jpg";
import img9 from "../../assets/images/screen9.jpg";
import { Context } from "../../context";
import classes from "./Project.module.css";

const InfoModal = ({ info, onClose }) => {
  const [title, setTitle] = useState("");
  const [textEn, setTextEn] = useState("");
  const [textIt, setTextIt] = useState("");
  const { debug, lang } = useContext(Context);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const [lightboxSrc, setLightboxSrc] = useState("");
  const lightboxRef = useRef();

  useEffect(() => {
    switch (info) {
      case "1":
        setTitle("Learning management system");
        setTextEn(
          "Platform to manage online video courses.<br />Management of admin, instructor and user accounts.<br />The user can purchase the course and follow the video lessons from his reserved area.<br />The instructor can create and manage the courses, publishing information and videos.<br />Each course can be divided into sections and lessons.<br /><br />"
        );
        setTextIt(
          "Piattaforma per gestire video corsi online.<br />Gestione di account admin, istruttore ed utente.<br />L'utente potrà acquistare il corso e seguire le video lezioni dalla sua area riservata.<br />L'istruttore potrà creare e gestire i corsi, pubblicando informazioni e video.<br />Ogni corso può essere diviso in sezioni e lezioni.<br /><br />"
        );
        break;
      case "2":
        setTitle("Ecommerce multi vendor");
        setTextEn(
          "Ecommerce platform multi vendor. Account user, vendor, admin.<br />Manage products, discount, coupon, blog, banner.<br /><br />"
        );
        setTextIt(
          "Piattaforma ecommerce multi venditore. Account venditore, utente, admin.<br />Gestione prodotti, sconti, coupon, blog, banner.<br /><br />"
        );
        break;
      case "3":
        setTitle("11111");
        setTextEn("dsfdsfdsfdsfdsfsdfsdfsdf");
        break;

      case "4":
        setTitle("Editor + Ecommerce");
        setTextEn(
          "Sitishop platform. Web site Editor and Ecommerce platform.<br /><br />"
        );
        setTextIt(
          "Piattaforma Sitishop. Editor siti web e piattaforma Ecommerce.<br /><br />"
        );
        break;

      case "5":
        setTitle("Editor + Tour Operator website");
        setTextEn(
          "Sitishop platform. Web site Editor and Tour Operator platform.<br />Accomodations and travels managements, booking engine multi accomodation.<br /><br />"
        );
        setTextIt(
          "Piattaforma Sitishop. Editor siti web e piattaforma per Tour Operator. Gestione strutture ricettive e viaggi, booking engine multi struttura.<br /><br />"
        );
        break;

      case "6":
        setTitle("Wedding online list");
        setTextEn(
          "Software for management wedding online list and birth online list.<br /><br />"
        );
        setTextIt(
          "Software gestione liste nozze e liste nascita online.<br /><br />"
        );
        break;

      case "8":
        setTitle("Food ecommerce");
        setTextEn(
          "Food ordering and publishing platform.<br />Ecommerce features.<br />Administrator, restaurant, user accounts.<br /><br />"
        );
        setTextIt(
          "Piattaforma per pubblicazione e gestione ordinazione di cibo.<br />Funzioni ecommerce.<br />Account amministratore, ristorante, utente.<br /><br />"
        );

        break;
      case "9":
        setTitle("Real estate");
        setTextEn(
          "Real estate properties posting platform.<br />Administrator and real estate agency account.<br /><br />"
        );
        setTextIt(
          "Piattaforma per pubblicazione annunci immobiliari.<br />Account amministratore ed agenzia immobiliare.<br /><br />"
        );
        break;
      default:
    }
  }, [info]);

  const CloseButton = ({ onClick }) => (
    <button className="lightbox-close-button" onClick={onClick}>
      Chiudi
    </button>
  );

  const openLightbox = (src) => {
    setLightboxOpen(true);
    setLightboxSrc(src);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setLightboxIndex(0);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (lightboxRef.current && !lightboxRef.current.contains(event.target)) {
        closeLightbox();
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const gallery = () => {
    switch (info) {
      case "1":
        return (
          <>
            <div className={`${classes.projectGalleryItem2}`}>
              <img
                src={img1}
                alt="gallery"
                className={classes.projectGalleryImg}
                onClick={() => openLightbox(img1)}
              />
              <img
                src={img2}
                alt="gallery"
                className={classes.projectGalleryImg}
                onClick={() => openLightbox(img2)}
              />
              <img
                src={img3}
                alt="gallery"
                className={classes.projectGalleryImg}
                onClick={() => openLightbox(img3)}
              />
            </div>
          </>
        );
      case "2":
        return (
          <>
            <div className={`${classes.projectGalleryItem}`}>
              <img
                src={img4}
                alt="gallery"
                className={classes.projectGalleryImg}
                onClick={() => openLightbox(img4)}
              />
              <img
                src={img5}
                alt="gallery"
                className={classes.projectGalleryImg}
                onClick={() => openLightbox(img5)}
              />
              <img
                src={img6}
                alt="gallery"
                className={classes.projectGalleryImg}
                onClick={() => openLightbox(img6)}
              />
            </div>
          </>
        );
      case "3":
        return <></>;

      case "4":
        return (
          <>
            <div className={`${classes.projectGalleryItem2}`}>
              <img
                src={img13}
                alt="gallery"
                className={classes.projectGalleryImg}
                onClick={() => openLightbox(img13)}
              />
              <img
                src={img14}
                alt="gallery"
                className={classes.projectGalleryImg}
                onClick={() => openLightbox(img14)}
              />
              <img
                src={img15}
                alt="gallery"
                className={classes.projectGalleryImg}
                onClick={() => openLightbox(img15)}
              />
            </div>
          </>
        );

      case "5":
        return (
          <>
            <div className={`${classes.projectGalleryItem2}`}>
              <img
                src={img16}
                alt="gallery"
                className={classes.projectGalleryImg}
                onClick={() => openLightbox(img16)}
              />
              <img
                src={img17}
                alt="gallery"
                className={classes.projectGalleryImg}
                onClick={() => openLightbox(img17)}
              />
              <img
                src={img18}
                alt="gallery"
                className={classes.projectGalleryImg}
                onClick={() => openLightbox(img18)}
              />
            </div>
          </>
        );

      case "6":
        return (
          <>
            <div className={`${classes.projectGalleryItem2}`}>
              <img
                src={img19}
                alt="gallery"
                className={classes.projectGalleryImg}
                onClick={() => openLightbox(img19)}
              />
              <img
                src={img20}
                alt="gallery"
                className={classes.projectGalleryImg}
                onClick={() => openLightbox(img20)}
              />
              <img
                src={img21}
                alt="gallery"
                className={classes.projectGalleryImg}
                onClick={() => openLightbox(img21)}
              />
            </div>
          </>
        );

      case "8":
        return (
          <>
            <div className={`${classes.projectGalleryItem2}`}>
              <img
                src={img10}
                alt="gallery"
                className={classes.projectGalleryImg}
                onClick={() => openLightbox(img10)}
              />
              <img
                src={img11}
                alt="gallery"
                className={classes.projectGalleryImg}
                onClick={() => openLightbox(img11)}
              />
              <img
                src={img12}
                alt="gallery"
                className={classes.projectGalleryImg}
                onClick={() => openLightbox(img12)}
              />
            </div>
          </>
        );
      case "9":
        return (
          <>
            <div className={`${classes.projectGalleryItem2}`}>
              <img
                src={img7}
                alt="gallery"
                className={classes.projectGalleryImg}
                onClick={() => openLightbox(img7)}
              />
              <img
                src={img8}
                alt="gallery"
                className={classes.projectGalleryImg}
                onClick={() => openLightbox(img8)}
              />
              <img
                src={img9}
                alt="gallery"
                className={classes.projectGalleryImg}
                onClick={() => openLightbox(img9)}
              />
            </div>
          </>
        );
      default:
        return "";
    }
  };

  return (
    <>
      <div className={`${classes.modal}`}>
        <div className={classes.modalContainer}>
          <div className={classes.modalHeader}>
            <span className={classes.modalTitle}>{title}</span>
            <div className={classes.modalButtonContainer}>
              <div onClick={onClose} className={classes.modalButton}>
                <FaWindowClose className={`${classes.FaWindowClose}`} />
              </div>
            </div>
          </div>
          <div className={classes.modalContent}>
            {lang === "en" ? <b> {parse(textEn)}</b> : <b>{parse(textIt)}</b>}

            {gallery()}
          </div>
        </div>
      </div>

      {lightboxOpen && (
        <Lightbox
          ref={lightboxRef}
          mainSrc={lightboxSrc}
          onCloseRequest={() => setLightboxOpen(false)}
          closeButtonReplacesBottomButtons={true}
          closeComponent={CloseButton}
        />
      )}
    </>
  );
};

export default InfoModal;
